import React from 'react';
import Masonry from 'react-masonry-css';
import './Gallery.css';

const Gallery = ({ mediaItems }) => {
  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
  };

  // Helper to safely get embed URL
  const getEmbedUrl = (url) => {
    if (!url) return '';
    return url.replace("watch?v=", "embed/");
  };

  if (!mediaItems || mediaItems.length === 0) {
    return (
      <div className="text-center py-5">
        <p className="text-muted">No media items found.</p>
      </div>
    );
  }

  return (
    <div className="gallery-section">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="gallery-masonry"
        columnClassName="gallery-masonry-column"
      >
        {mediaItems.map((item) => (
          <div key={item.id} className="gallery-card">
            {item.content_type === "photo" ? (
              <div className="image-wrapper">
                <img 
                  src={item.photo} 
                  alt={`Gallery Item ${item.id}`} 
                  loading="lazy" 
                />
                <div className="overlay">
                  <span className="plus-icon">+</span>
                </div>
              </div>
            ) : (
              <div className="video-wrapper">
                <iframe
                  src={getEmbedUrl(item.youtube_link)}
                  title={`Video ${item.id}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            )}
          </div>
        ))}
      </Masonry>
    </div>
  );
};

export default Gallery;